export default function AlertsViewDeleteController(
  $scope,
  $uibModalInstance,
  configuration,
  $state,
  configurationsService,
  gettextCatalog
) {
  'ngInject';

  $scope.configuration = configuration;
  $scope.loading = false;
  $scope.errorFlag = false;
  $scope.errorText = '';

  $scope.ok = function() {
    $scope.loading = true;
    configurationsService.deleteConfiguration($scope.configuration.id).then(
      function(response) {
        $uibModalInstance.close();
        $state.go('alerts.configurations.list');
      },
      function(error) {
        var errorMsg = gettextCatalog.getString('An error occurred while deleting the configuration');
        $scope.errorFlag = true;
        $scope.errorText = errorMsg;
        $scope.loading = false;
      }
    );
  };

  $scope.cancel = function() {
    $uibModalInstance.close('cancel');
  };

  $scope.$on('$locationChangeStart', function(event, next, current) {
    $scope.cancel();
  });
}
